<div [id]="menuOption.id" *ngIf="menuOption" class="menu-option" (click)="handleClick($event)"
  [ngClass]="{ 'active': isActiveRoute(), 'hidden' : isHidden(), 'collapsed' : isCollapsed() }"
     appTooltip [text]="getTooltipText()" position="right">
  <img class="icon" [src]="menuOption.icon?.value" alt="{{menuOption.label}} icon"/>
  <label *ngIf="state === 'open'" class="title">{{menuOption.label}}</label>
  <div *ngIf="hasNoEmptySubmenu() && showCaret()" class="submenu-button">
    <img class="caret" ngSrc="assets/icons/caret/caretRight.svg" alt="right caret" height="8" width="8">
  </div>
</div>
